import { put, all, call, takeEvery } from "redux-saga/effects";
import { notificationGetApi, notificationCreateApi, notificationUpdateApi, notificationDeleteApi, notificationSendApi } from "../api";
import {
  ntfyMngmntGetSuccess,
  ntfyMngmntCreateSuccess,
  ntfyMngmntUpdateSuccess,
  ntfyMngmntGetError,
  ntfyMngmntCreateError,
  ntfyMngmntUpdateError,
  myNtfyMngmntGetSuccess,
  userNtfyMngmntGetSuccess,
  ntfyMngmntDeleteSuccess,
  ntfyMngmntDeleteError,
  ntfyMngmntDefaultSuccess,
  ntfyMngmntSendSuccess,
  ntfyMngmntSendError,
} from "../actions";
import { notificationManagement } from "../../constants/actionTypes";
import { notificationManagementConstant, toasterFlags } from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";
import { statusCode } from "../../constants/apis/apiStatus";

export function* fetchNotificationListMainSaga({ data, searchType }) {
  try {
    const notificationGetData = yield call(notificationGetApi, data);
    if (notificationGetData?.status === statusCode.Ok200) {
      if (searchType === notificationManagementConstant.notification) {
        yield put(ntfyMngmntGetSuccess(notificationGetData?.data));
      } else if (searchType === notificationManagementConstant.myNotifications) {
        yield put(myNtfyMngmntGetSuccess(notificationGetData?.data));
      } else if (searchType === notificationManagementConstant.users) {
        yield put(userNtfyMngmntGetSuccess(notificationGetData?.data));
      } else if (searchType === notificationManagementConstant.default) {
        yield put(ntfyMngmntDefaultSuccess(notificationGetData?.data));
      }
    } else {
      toastNotification(toasterFlags.ERROR, `${notificationGetData?.error}`);
      yield put(ntfyMngmntGetError(notificationGetData));
    }
  } catch (err) {
    yield put(ntfyMngmntGetError(err));
  }
}

export function* notificationCreateMainSaga({ data }) {
  try {
    const notificationCreateData = yield call(notificationCreateApi, data);
    if (notificationCreateData?.status === statusCode.Created201) {
      yield put(ntfyMngmntCreateSuccess(notificationCreateData?.data));
    } else {
      toastNotification(toasterFlags.ERROR, `${notificationCreateData?.error}`);
      yield put(ntfyMngmntCreateError(notificationCreateData));
    }
  } catch (err) {
    yield put(ntfyMngmntCreateError(err));
  }
}

export function* notificationUpdateMainSaga({ id, formData }) {
  try {
    const notificationUpdateData = yield call(notificationUpdateApi, id, formData);
    if (notificationUpdateData?.status === statusCode.Created201) {
      yield put(ntfyMngmntUpdateSuccess(notificationUpdateData?.data));
    } else {
      toastNotification(toasterFlags.ERROR, `${notificationUpdateData?.error}`);
      yield put(ntfyMngmntUpdateError(notificationUpdateData));
    }
  } catch (err) {
    yield put(ntfyMngmntUpdateError(err));
  }
}

export function* notificationDeleteMainSaga({ data }) {
  try {
    const notificationDeleteData = yield call(notificationDeleteApi, data);
    if (notificationDeleteData?.status === statusCode.Ok200) {
      yield put(ntfyMngmntDeleteSuccess(notificationDeleteData?.data));
    } else {
      toastNotification(toasterFlags.ERROR, `${notificationDeleteData?.error}`);
      yield put(ntfyMngmntDeleteError(notificationDeleteData?.data));
    }
  } catch (err) {
    yield put(ntfyMngmntDeleteError(err));
  }
}

export function* notificationSendMainSaga({ data }) {
  try {
    const notificationSendData = yield call(notificationSendApi, data);
    if (notificationSendData) {
      yield put(ntfyMngmntSendSuccess(notificationSendData));
      toastNotification(toasterFlags.SUCCESS, `${notificationSendData?.Success[0]}`);
    } else {
      yield put(ntfyMngmntSendError(notificationSendData));
      toastNotification(toasterFlags.ERROR, `${notificationSendData?.error}`);
    }
  } catch (err) {
    yield put(ntfyMngmntSendError(err));
  }
}

export function* notificationSaga() {
  yield takeEvery(notificationManagement.NOTIFICATION_MANAGEMENT_GET_REQUEST, fetchNotificationListMainSaga);
  yield takeEvery(notificationManagement.NOTIFICATION_MANAGEMENT_CREATE_REQUEST, notificationCreateMainSaga);
  yield takeEvery(notificationManagement.NOTIFICATION_MANAGEMENT_UPDATE_REQUEST, notificationUpdateMainSaga);
  yield takeEvery(notificationManagement.NOTIFICATION_MANAGEMENT_DELETE_REQUEST, notificationDeleteMainSaga);
  yield takeEvery(notificationManagement.NOTIFICATION_MANAGEMENT_SEND_REQUEST, notificationSendMainSaga);
}

export default function* rootSaga() {
  yield all([notificationSaga()]);
}
